import { createContext, useContext } from "react";

// Lets entity editors (Courses, Projects, Media, Journal) register a saver so the
// top-bar "Salvează"/"Publică" buttons also persist the currently open form.
export const AdminSaveContext = createContext({ registerSaver: () => {} });
export const useAdminSave = () => useContext(AdminSaveContext);
